import { InsightsNavbar } from "@/components/InsightsNavbar";
import { AnimatedSection } from "@/components/AnimatedSection";
import { ScrollProgressIndicator } from "@/components/ScrollProgressIndicator";
import { Footer } from "@/components/Footer";
import { InsightsLeadModal } from "@/components/InsightsLeadModal";
import { InsightsBreadcrumb } from "@/components/InsightsBreadcrumb";
import { GeoVsSeoHeroSection } from "@/components/insights/geo-vs-seo/GeoVsSeoHeroSection";
import { GeoVsSeoTakeaway } from "@/components/insights/geo-vs-seo/GeoVsSeoTakeaway";
import { GeoVsSeoFounderQuote } from "@/components/insights/geo-vs-seo/GeoVsSeoFounderQuote";
import { GeoVsSeoKeyFindings } from "@/components/insights/geo-vs-seo/GeoVsSeoKeyFindings";
import { GeoVsSeoStrategies } from "@/components/insights/geo-vs-seo/GeoVsSeoStrategies";
import { GeoVsSeoComparison } from "@/components/insights/geo-vs-seo/GeoVsSeoComparison";
import { InsightSEO } from "@/hooks/useInsightSEO";
import { RelatedTools } from "@/components/RelatedTools";
import { InsightEngagementTracker } from "@/components/InsightEngagementTracker";
import { InsightFAQSection } from "@/components/InsightFAQSection";
import { InsightBenchmarks } from "@/components/InsightBenchmarks";
import { TableOfContents } from "@/components/TableOfContents";

const GeoVsSeo = () => {
  return (
    <>
      <InsightSEO 
        slug="geo-vs-seo" 
        additionalKeywords={["GEO optimization", "generative engine optimization", "AI search ranking", "ChatGPT SEO", "Perplexity ranking", "AI citations"]}
      />
      <InsightEngagementTracker slug="geo-vs-seo" title="GEO vs SEO" />
      <InsightsNavbar showBack />
      <ScrollProgressIndicator />
      <TableOfContents />
      <InsightsLeadModal />
      <main className="page-container pb-16 sm:pb-20">
        <InsightsBreadcrumb 
          category="AI Development" 
          currentPage="GEO vs SEO" 
        />
        <GeoVsSeoHeroSection />
        
        <AnimatedSection delay={100} className="mt-10 sm:mt-12">
          <GeoVsSeoTakeaway />
        </AnimatedSection>

        <AnimatedSection delay={50} className="mt-8 sm:mt-10">
          <GeoVsSeoFounderQuote />
        </AnimatedSection>

        <div className="section-divider" />

        <AnimatedSection delay={0}>
          <GeoVsSeoKeyFindings />
        </AnimatedSection>
        
        <AnimatedSection delay={0}>
          <GeoVsSeoComparison />
        </AnimatedSection>
        
        <AnimatedSection delay={0}>
          <GeoVsSeoStrategies />
        </AnimatedSection>
        
        {/* Benchmark Tables */}
        <AnimatedSection delay={0}>
          <InsightBenchmarks insightSlug="geo-vs-seo" />
        </AnimatedSection>
        
        {/* FAQ Section */}
        <AnimatedSection delay={0}>
          <InsightFAQSection insightSlug="geo-vs-seo" />
        </AnimatedSection>
        
        {/* Related Tools Section */}
        <AnimatedSection delay={0}>
          <RelatedTools insightSlug="geo-vs-seo" />
        </AnimatedSection>
      </main>
      <Footer />
    </>
  );
};

export default GeoVsSeo;